import {SubmissionError} from 'redux-form';
import i18n from 'i18n';
export const checkRequiredFields = (requiredFieldsNames, formValues) => {
    let errors = {};
    let isError = false;
    for (let i = 0; i < requiredFieldsNames.length; i++) {
        const val = formValues[requiredFieldsNames[i]];
        if (!val) {
            errors[requiredFieldsNames[i]] = i18n.t('please_fill_this_field');
            isError = true;
        }
    }
    if (isError) {
        throw new SubmissionError(errors);
    }
};


// WEBPACK FOOTER //
// ./src/forms.js